// extracted by mini-css-extract-plugin
module.exports = {"detail":"TVDetailContent_detail__61dtW","loading":"TVDetailContent_loading__2tQis","error":"TVDetailContent_error__1sy8C"};